import { render, staticRenderFns } from "./batchPayFeeOrderList.vue?vue&type=template&id=65477ba6&scoped=true"
import script from "./batchPayFeeOrderList.vue?vue&type=script&lang=js"
export * from "./batchPayFeeOrderList.vue?vue&type=script&lang=js"
import style0 from "./batchPayFeeOrderList.vue?vue&type=style&index=0&id=65477ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65477ba6",
  null
  
)

export default component.exports